module.exports = {
  schedule: function(fn) {
    setTimeout(fn, 0);
  }
};
